<template>
  <!-- 案件詳細 -->
  <div id="PSGRequestDetail">
    <div  id="item-contens" style="text-align:right;">
        <b-button v-if="requestCancel" class="is-primary" style="margin-right:3%;" @click="cancelReasonInputModalActive=true">解析をキャンセル</b-button>
    </div>
    <div id="item-contens">
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size: 20px">依頼内容</span>
        <table>
          <tr><th>医療機関名</th>
            <td v-if="isClipboardCopy" style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">
              <a @click="clipboardCopy(data.copyHospitalName)"><b-icon icon="paperclip" />{{data.hospitalName}}</a>
            </td>
            <td v-else style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.hospitalName}}</td>
          </tr>
          <tr><th>医師名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.doctorName}}</td></tr>
          <tr><th>事務担当者名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.clerkName}}</td></tr>
          <template v-if="data.isNotHospital">
            <tr><th>医療機関メールアドレス</th><td><b-checkbox style="width: 26px" value="true" disabled v-model="data.isResultMailSend"></b-checkbox>解析結果のダウンロードURLを医療機関にメールで通知する。</td></tr>
            <tr v-if="data.isResultMailSend"><th></th><td>{{data.hospitalMail}}</td></tr>
          </template>
          <tr><th>検査の種類</th><td>{{inspectionType}}</td></tr>
          <tr><th>解析方法</th><td>{{data.analysisMethod | choiceFilter(analysisMethodList)}}</td></tr>
          <template v-if="isWP(data.analysisMethod)">
            <tr><th>いびきセンサー同梱の有無</th><td>{{setSnoreSensorValue(data.snoreSensor)}}</td></tr>
          </template>
          <tr><th>SleepwareG3のバージョン</th><td>{{data.sleepwareG3Version | choiceFilter(sleepwareVersionList)}}</td></tr>
          <tr>
            <th>レポート形式</th>
              <td v-if="isInternalPsg" style="color: red">{{data.reportFormat | choiceFilter(reportFormatList)}}</td>
              <td v-if="!isInternalPsg">{{data.reportFormat | choiceFilter(reportFormatList)}}</td>
          </tr>
          <tr><th>お急ぎ便利用</th><td><b-checkbox style="width: 26px" v-model="data.urgentConvenience" disabled/>お急ぎ便を利用する。</td></tr>
          <tr v-if="data.urgentConvenience"><th>お急ぎ便利用理由</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"><div class="indentionArea printIndentionArea">{{data.urgentConvenienceReasons}}</div></td></tr>
          <tr><th>返却希望日</th><td>{{data.returnDate | dateFilter}}</td></tr>
          <tr v-if="belongsNote">
            <th style="vertical-align:top;">外部ユーザーコメント</th>
              <td v-if="isInternalPsg" style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;color: red">{{belongsNote}}</td>
              <td v-if="!isInternalPsg" style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{belongsNote}}</td>
          </tr>
          <tr>
            <th v-if="hstRequestId" style="vertical-align:top;">申送り事項</th>
            <th v-else style="vertical-align:top;">備考</th>
            <td v-if="!editFlag" style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"><div class="indentionArea printIndentionArea">{{data.biko}}</div></td>
            <td v-if="editFlag"><textarea v-model="data.biko" maxlength="256" style="resize:vertical;max-width:100%;height:50px;"></textarea></td>
          </tr>
          <tr><th>納品書</th><td><span v-if="data.deliverySlip">必要</span><span v-else>不要</span></td>
          <tr><th>デモ</th><td><b-checkbox style="width: 26px" v-model="data.demo" disabled/>デモ(トライアル)</td></tr>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size: 20px">患者情報</span>
        <table>
          <tr><th>診察券ID（患者ID）</th>
            <td v-if="isClipboardCopy"><a @click="clipboardCopy(data.patientId)"><b-icon icon="paperclip" />{{data.patientId}}</a></td>
            <td v-else>{{data.patientId}}</td>
          </tr>
          <tr><th>患者名</th>
            <td v-if="isClipboardCopy" style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">
              <a @click="clipboardCopy(data.patientFamilyName)"><b-icon icon="paperclip" />{{data.patientFamilyName}}</a> <a @click="clipboardCopy(data.patientFirstName)"><b-icon icon="paperclip" />{{data.patientFirstName}}</a>
            </td>
            <td v-else style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patientFamilyName}} {{data.patientFirstName}}</td>
          </tr>
          <tr><th>患者名（カナ）</th><td>{{data.patientFamilyNameKana}} {{data.patientFirstNameKana}}</td></tr>
          <tr><th>性別</th><td>{{data.gender}}</td></tr>
          <tr><th>生年月日</th><td>{{data.birthday | dateFilter}}<span v-if="data.birthday" style="margin-left:10px;">{{data.japaneseCalendar}}</span></td></tr>
          <tr><th>年齢</th><td>{{data.age}}</td></tr>
          <tr><th>身長</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.height}}</td></tr>
          <tr><th>体重</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.weight}}</td></tr>
          <tr><th>BMI</th><td>{{data.bmi}}</td></tr>
          <tr><th>基礎疾患・合併症</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"><div class="indentionArea printIndentionArea">{{data.basicIllnessComplications}}</div></td></tr>
          <tr><th>投薬状況</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"><div class="indentionArea printIndentionArea">{{data.dosingStatus}}</div></td></tr>
          <tr><th>主訴</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"><div class="indentionArea printIndentionArea">{{data.chiefComplaint}}</div></td></tr>
          <tr><th style="vertical-align:top;">備考</th>
            <td v-if="!editFlag || hstRequestId" style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"><div class="indentionArea printIndentionArea">{{data.patientBiko}}</div></td>
            <td v-else-if="editFlag"><textarea v-model="data.patientBiko" maxlength="256" style="resize:vertical;max-width:100%;height:100px;"></textarea></td>
          </tr>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size: 20px">解析データ情報</span>
        <table v-if="data.analysisDataInfo">
          <tr><th>検査目的</th><td>{{data.analysisDataInfo.inspectionPurpose | choiceFilter(inspectionPurposeList)}}</td></tr>
          <tr><th>検査目的（その他）</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"><div class="indentionArea printIndentionArea">{{data.analysisDataInfo.inspectionPurposeMemo}}</div></td></tr>
          <tr><th>設定圧</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"><div class="indentionArea printIndentionArea">{{data.analysisDataInfo.setPressure}}</div></td></tr>
          <tr><th>消灯時刻</th><td>{{data.analysisDataInfo.offTime}}</td></tr>
          <tr><th>点灯時刻</th><td>{{data.analysisDataInfo.onTime}}</td></tr>
          <tr><th>消灯点灯に関する追加指示</th><td>{{data.analysisDataInfo.offTimeAdditionalInstructions | choiceFilter(offTimeAdditionalInstructionsList)}}</td></tr>
          <tr>
            <th v-if="hstRequestId" style="vertical-align:top;">配送情報備考</th>
            <th v-else style="vertical-align:top;">備考</th>
            <td v-if="!editFlag || hstRequestId" style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"><div class="indentionArea printIndentionArea">{{data.analysisDataInfo.biko}}</div></td>
            <td v-else-if="editFlag"><textarea v-model="data.analysisDataInfo.biko" maxlength="256" style="resize:vertical;max-width:100%;height:100px;"></textarea></td>
          </tr>
          <tr><th class="valign-top">添付データ
              <b-button v-if="canUpdate && !editMode" class="is-primary replaceButton" icon-left="file-replace-outline" @click="replace">差し替え</b-button>
              <div style="float:right; width:120px">
                <b-button v-if="canUpdate && editMode" class="is-primary replaceButton" icon-left="cloud-upload-outline " @click="upload" >保存</b-button>
                <b-button v-if="canUpdate && editMode" class="is-primary replaceButton" style="margin-top:5px;" @click="back" >戻る</b-button>
              </div>
            </th>
            <td>
              <template v-if="editMode">
                <div class="upload_area uploadArea" @dragenter="dragEnter">
                  ここに添付する解析データをドラッグアンドドロップするか、「ファイルを追加」を押します。
                </div>
                <b-modal :active.sync="isUpdateModal" has-modal-card>
                  <div class="modal-card uploadModal" 
                   @dragleave="dragLeave"
                   @drop.prevent="fileDorop"
                  >
                  ここに解析データファイルをドロップします。
                  </div>
                </b-modal>
                <b-upload v-model="upButtonFile"  class="file-label" v-on:input="addUploadfile" multiple>
                  <span class="file-cta">
                    <span class="file-label">ファイルを追加</span>
                  </span>
                </b-upload>
                <ul class="upfileList">
                  <li v-for="(file,index) of replaceFiles" :key="index">
                    <div v-if="file.ctrl" class="fileNameArea line-through"><b-icon icon="paperclip" />{{file.name}}</div>
                    <div v-else class="fileNameArea"><b-icon icon="paperclip" />{{file.name}}</div>
                    <b-checkbox class="cstmCheckBox deletecheck" v-model="file.ctrl">削除する</b-checkbox>
                  </li>
                </ul>
              </template>
              <template v-if="!editMode">
                <ul>
                  <li v-for="(file,index) of replaceFiles" :key="index">
                    <template v-if="file.ctrl">
                      <div class="fileName line-through"><b-icon icon="paperclip" />{{file.name}}</div>
                    </template>
                    <template v-else>
                      <template v-if="file.fileAddress"><a @click="downloadFile(file.fileAddress, file.fileId)"><b-icon icon="paperclip" />{{file.name}}</a></template>
                      <template v-else-if="canDownload"><a @click="downloadFile(file.path, file.fileId)"><b-icon icon="paperclip" />{{file.name}}</a></template>
                      <template v-else><b-icon icon="paperclip" />{{file.name}}</template>
                    </template>
                  </li>
                </ul>
              </template>
            </td>
          </tr>
        </table>
      </div>
      <b-modal :active.sync="cancelReasonInputModalActive" has-modal-card>
        <reasonInputModal  v-on:setReason="cancel" v-bind:title="'検査キャンセル(キャンセル理由入力)'"></reasonInputModal>
      </b-modal>
    </div>
  </div>
</template>

<script>
import {UploadType} from "@/components/mock/base/const.js";
import {choicesType} from "@/components/mock/base/const.js";
import {psgAnalysisValue} from "@/components/mock/base/const.js";
import reasonInputModal from "@/components/mock/philips/common/reasonInputModal";

export default {
  name: "PSGRequestDetail",
  props: ["data","canUpdate","canDownload","editFlag","hstRequestId","belongsNote","isInternalPsg","requestCancel","isClipboardCopy"],
  methods: {
    replace: function(){
      this.editMode = true;
      this.replaceFiles = this.getCopy(this.data.analysisDataInfo.attachedDataFileList);
      this.$nextTick(() => {
          //DOMが更新された後に呼ばれるコールバック
          var element = document.getElementById("PSGRequestDetail").parentElement;
          if(element){
            element.scrollTop = element.scrollHeight;  //スクロールバーを一番下に移動する
          }
      })      
    },
    back: function(){
      this.editMode = false;
      this.replaceFiles = this.getCopy(this.data.analysisDataInfo.attachedDataFileList);
    },
    upload: async function(){
      let nameCheckList = this.replaceFiles.filter(val => !val.ctrl)
      let nameList = nameCheckList.map(item => item['name']);
      for(let i =0; i < nameList.length; i++){
        if(nameList[i].startsWith("/")){
          //フォルダの場合はzip名にしてチェック
          nameList[i] = nameList[i].replace("/", "") + ".zip"
        }
      }
      const setElements = new Set(nameList);
      if (setElements.size !== nameList.length) {
        this.showErrorMessage("添付データの重複しているファイルが存在します。")
        return
      }
      var targetFile = this.replaceFiles.filter(val => !val.ctrl && !val.fileId)
      let okSize = await this.checkUploadFileSize(targetFile)
      if(!okSize){
        this.showErrorMessage("2GBを超えるファイルはアップロードできません。")
        return
      }
      //まずはファイルのアップロード
      this.multipleUpload(targetFile ,this.data.analysisDataInfo.receiptNumber, this.UploadType.psg_data, "")
      .then(result => {
        var deleteFile = this.replaceFiles.filter(val => val.ctrl && val.fileId)
        var delFileId = []
        if (deleteFile.length > 0) {
          deleteFile.forEach(ele => {
            delFileId.push(ele.fileId)
          });
        }
        this.replacePsgApplicationFile(delFileId);
      }).catch(error =>{
        this.showErrorMessage("ファイルアップロードに失敗しました。<br>再度実行してください。");
      });

    },
    replacePsgApplicationFile: function(delFileId) {
      let _this = this;
      this.apiCall(
        function(client){
          return client.apis.externalPsg.replacePsgApplicationFilePOST({
            body:{
              receiptNumber:_this.data.analysisDataInfo.receiptNumber,
              deleteFileId: delFileId
            }
          });        
        },
        async function(result){
          let receiptNumber = _this.data.analysisDataInfo.receiptNumber
          await _this.getDetail(receiptNumber);
          _this.editMode = false;
          _this.canUpdate = false;
          _this.$emit("finish-psg");
          _this.showMessage("登録が完了しました。");
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    downloadFile: function(fileAddress, fileId){
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.getDownloadFilePOST({
            body:{
              fileId:fileId,
              fileName:fileAddress
            }
          });
        },
        function(result){
          if(result != null && result.status == 200){
            var downloadUrl = result.obj.downloadUrl;
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.href = downloadUrl;
            let targetFile = fileAddress.toLowerCase();
            if(targetFile.endsWith(".pdf")){
              a.target="_blank"
            }
            a.click();
            a.remove();
          } else if(result != null){
            _this.showErrorMessage(result.message);
          } else {
            _this.showErrorMessage("予期しないエラーが発生しました。");
          }
        },
        function(error){
          // エラーメッセージ表示
          _this.showErrorMessage(error);
        }
      );
      
    },
    dragEnter: function() {
      this.isUpdateModal = true;
    },
    dragLeave: function() {
      console.log("dragLeave")
      this.isUpdateModal = false;
    },
    fileDorop: function(event) {
      console.log("fileDorop")
      for(let i =0 ; i < event.dataTransfer.items.length; i++){
        const item = event.dataTransfer.items[i];
        const entry = item.webkitGetAsEntry();
        let path = entry.name;
        if(entry.isDirectory){
          path = entry.fullPath;
        }
        this.replaceFiles.push({ file: entry, path: path , name:path});
      }
      this.isUpdateModal = false;
    },
    addUploadfile: function(){
      for(let upFile of this.upButtonFile){
        this.replaceFiles.push({ file: upFile, path: upFile.name,name:upFile.name })
      }
      this.upButtonFile = [];
    },
    getDetail: async function(receiptNumber){
      let _this = this;
      this.apiCall(
        function(client){
          return client.apis.externalRequestSearch.getApplicationListPOST({
            body: { receiptNumber: receiptNumber}
          });
        },
        function(result){
          _this.data.analysisDataInfo.attachedDataFileList = result.obj[0].applicationDetails.analysisDataInfo.attachedDataFileList;
          _this.inspectionType= _this.data.fullFlag ? "フルPSG検査" : "簡易検査",
          _this.replaceFiles = _this.getCopy(_this.data.analysisDataInfo.attachedDataFileList)
        },
        function(error) {
          _this.showErrorMessage(error);
        }
      );
    },
    updateAattachedDataFileList(){
      this.replaceFiles = this.getCopy(this.data.analysisDataInfo.attachedDataFileList)
    },
    isWP: function(analysisMethod) {
      if(analysisMethod == psgAnalysisValue.WP){
        return true
      }
      return false
    },
    setSnoreSensorValue: function(snoreSensor) {
      var setSnoreSensorValue = !snoreSensor || snoreSensor === "1" ? "無" : "有";
      return setSnoreSensorValue;
    },
    cancel: function(cancelReason) {
      this.$emit('cancel', "PSG", cancelReason);
      this.$parent.close();
    },
    clipboardCopy: function(copyStr){
      navigator.clipboard.writeText(copyStr).then(() => {
        this.showMessage('クリップボードにコピーしました。');
      }).catch(err => {
        this.showMessage('コピーに失敗しました');
      });
    },
  },
  data() {
    let analysisMethodList = this.getChoiceList(choicesType.psgMethod, true);
    let sleepwareVersionList = this.getChoiceList(choicesType.sleepwareG3Ver, true);
    let reportFormatList = this.getChoiceList(choicesType.psgReportFormat, true);
    let inspectionPurposeList = this.getChoiceList(choicesType.inspectionPurpose, true);
    let offTimeAdditionalInstructionsList = this.getChoiceList(choicesType.turnOnOff, true);
    if(this.data.birthday){
      const date = new Date(this.data.birthday);
      const options = {era: 'long'};
      this.data["japaneseCalendar"]  = "【"+this.getJapaneseCalendar(date)+"】"
    }
    return {
      UploadType:UploadType,
      inspectionType:this.data.fullFlag ? "フルPSG検査" : "簡易検査",
      editMode:false,
      isUpdateModal:false,
      upButtonFile:null,
      analysisMethodList: analysisMethodList,
      sleepwareVersionList: sleepwareVersionList,
      reportFormatList: reportFormatList,
      inspectionPurposeList: inspectionPurposeList,
      offTimeAdditionalInstructionsList: offTimeAdditionalInstructionsList,
      replaceFiles: this.getCopy(this.data.analysisDataInfo.attachedDataFileList),
      cancelReasonInputModalActive:false
    };
  },
  filters: {
    choiceFilter: function(val, list){
      if(!val) return val
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    },
    dateFilter: function(val){
      if(!val) return val
      return val.replace(/-/g, "/")
    },
  },
  components: {
    reasonInputModal:reasonInputModal
  },
  mounted: async function() {
    if(this.canUpdate){
      let receiptNumber = this.data.analysisDataInfo.receiptNumber;
      await this.getDetail(receiptNumber);
    }
  }
};
</script>
<style lang="scss" scoped>
.valign-top {
  vertical-align: top !important;
}
.replaceButton {
  margin-right:10px;
  width:100px;
}
.uploadModal {
  width: 900px !important;
  height:500px !important;
  display: grid !important;
  place-items: center !important;
}
.uploadArea {
  height: 60px !important;
  text-align: left;
  line-height: 20px;
  padding: 10px;
}
.uplad_button {
  margin-top:10px;
}
.upfileList {
  margin-top:10px;
}
.upfileList>li{
  margin-top:5px;
  display: flex;
}
.fileName {
  width: 100%;
  word-wrap: break-word;
}
.fileName.line-through {
  text-decoration: line-through;
}
.fileNameArea {
  width: 250px;
  word-wrap: break-word;
}
.fileNameArea.line-through {
  text-decoration: line-through;
}

.deletecheck {
  margin-left:5px;
}
a {
  text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/common/PSGRequestDetail.vue